import { SUBCLUSTERS } from '../subclusters.js';

const DESIGN_AND_CREATIVE_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.CREATIVE_PLANNING,
        },
        {
            key: SUBCLUSTERS.CONTENT_CALENDAR,
        },
        {
            key: SUBCLUSTERS.MEDIA_PRODUCTION,
        },
        {
            key: SUBCLUSTERS.CREATIVE_REQUESTS,
        },
        {
            key: SUBCLUSTERS.PRODUCT_LAUNCHES,
        },
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.CLIENT_PROJECTS,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
        {
            key: SUBCLUSTERS.SOFTWARE_DEVELOPMENT,
        },
    ],
};

export { DESIGN_AND_CREATIVE_CLUSTER };
